var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"card"},[_c('div',{staticClass:"card-body"},[_c('h4',{staticClass:"card-title"},[_vm._v("Kas / Bank")]),_c('span',{staticClass:"text-danger"},[_vm._v("Coming soon")])])])
}]

export { render, staticRenderFns }